import { Controller } from 'react-hook-form';
import InputFileUpload from '../../inputs/image/image';
import { FormProps } from '../../../shared/interfaces/form';

interface FormImageProps {
  item: FormProps;
  index: number;
  baseId: string;
  errors: any;
  control: any;
  isDisabled: boolean;
  setValue: (name: string, value: any) => void;
  getValues: (name?: string | string[]) => any;
}

const FormImage = ({
  item,
  index,
  baseId,
  errors,
  control,
  isDisabled,
  setValue,
  getValues
}: FormImageProps) => {
  
  const handleFileChange = (file: any, onChange: any) => {
    onChange(file);
  };
  
  return (
    <Controller
      key={`image-${index}-${baseId}`}
      name={item.name}
      control={control}
      defaultValue=""
      rules={item.rules}
      render={({ field }) => (
        <InputFileUpload
          placeholder={item.placeholder}
          error={errors[item.name]?.message}
          width="100%"
          height={item.height}
          disabled={isDisabled}
          name={field.name}
          value={field.value || null}
          onChange={(file: any) => handleFileChange(file, field.onChange)}
          ref={field.ref}
        />
      )}
    />
  );
};

export default FormImage;